import ChartApi from '../../../pages/delincuencia/delincuencia-v2/ChartApi';
 
export const MainCP = () => {
  return (
    <div className="container-fluid">
      <div className="row" style={{ marginTop: '40px' }}>
        <div className="col-12">
          <div className="d-flex justify-content-center">
            <ChartApi />
          </div>
        </div>
      </div>
    </div>
  )
}
 